/**
 * Deliberate localStorage persistence (EXT-622). The TV app runs inside the
 * native shell's iframe — the pairing-code session must survive reloads.
 * Every helper is safe when localStorage is unavailable (storage-partitioned
 * or blocked iframes): it no-ops/returns null instead of throwing.
 */
export const storageKey = 'Hoxx';

const prefixed = (key: string) => `${storageKey}:${key}`;

export const SaveObject = (key: string, value: unknown): void => {
  try {
    localStorage.setItem(prefixed(key), JSON.stringify(value));
  } catch {
    // storage blocked/full — persistence is best-effort
  }
};

export const ReadObject = <T = unknown>(key: string): T | null => {
  try {
    const raw = localStorage.getItem(prefixed(key));
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
};

export const RemoveObject = (key: string): void => {
  try {
    localStorage.removeItem(prefixed(key));
  } catch {
    // storage blocked — nothing to remove
  }
};
